
import React from 'react';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { FontIcon } from 'office-ui-fabric-react/lib/Icon';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { Text } from 'office-ui-fabric-react/lib/Text';
import GeoJSON from 'ol/format/GeoJSON';
import { useDispatch, useSelector  } from 'react-redux';

import { addEventListener, DialogAlert, IfComp, removeEventListener, ToolbarCommandButton } from '../../core';
import { getSearchProjectId } from '../../project';

import { getActions } from '../sagas';

import GeneratePolygonDialog from './GeneratePolygonDialog';

const classNames = mergeStyleSets({
    title: {
        paddingTop: 8,
        paddingBottom: 8
    },
    geometryParam: {
        borderBottom: '1px solid #dddddd',
        paddingBottom: 8,
        paddingTop: 4
    },
    noGeometry: {
        color: '#ff0000'
    }
});

const GeometryParam = ({
    generatePolygonDefinition,
    tempFeature,
    onSetGeometry
}) => {

    const dispatch = useDispatch();
    const searchActions = getActions(dispatch);

    const searchProjectId = useSelector(state => getSearchProjectId(state.project));


    const handleClickGenerate = async () => {

        const dialog = GeneratePolygonDialog();
        let res = await dialog.open(generatePolygonDefinition.params);

        if ((res.button === 1) && onSetGeometry) {
            let desc = 'generatePolygon';

            let searchData = {
                params: Object.keys(res.values).map(item => {
                    return {
                        id: item,
                        value: res.values[item]
                    };
                })
            };

            const eventFunc = async (event) => {
                removeEventListener('search.searchresult', eventFunc);
                if (event.result.objects.length > 0) {
                    let title = event.result.objects[0].title;
                    let geomGeoJSON = event.result.objects[0].geom;
                    let format = new GeoJSON();
                    let geom = format.readGeometry(geomGeoJSON);
                    onSetGeometry(geom, true, title);
                } else {
                    await DialogAlert.show('Za zadaných parametrů se polygon nepodařilo vygenerovat');
                }
            };
            addEventListener('search.searchresult', eventFunc);

            searchActions.doSearch(
                searchProjectId, generatePolygonDefinition.id, searchData,
                {desc: desc, silent: true}, true, 'SET'
            );
        }
    }

    const handleClickRemove = () => {
        if (onSetGeometry) {
            onSetGeometry(null, false, '');
        }
    }

    let commands = [];
    if (generatePolygonDefinition) {
        commands.push({
            text: 'Generovat',
            title: 'Vygenerovat polygon',
            onClick: handleClickGenerate
        });
    }

    if (tempFeature) {
        commands.push({
            text: 'Odstranit',
            title: 'Odstranit polygon',
            onClick: handleClickRemove
        });
    }

    return (
        <Stack.Item className={classNames.geometryParam}>
            <IfComp cond={!!tempFeature}>
                <Stack horizontal>
                    <FontIcon iconName="LocationDot" />
                    <Stack.Item>polygon je zadaný</Stack.Item>
                </Stack>
            </IfComp>
            <IfComp cond={!tempFeature}>
                <Stack horizontal>
                    <FontIcon iconName="LocationDot" />
                    <Stack.Item className={classNames.noGeometry}>zadejte polygon</Stack.Item>
                </Stack>
            </IfComp>
            <ToolbarCommandButton
                items={commands}
            />
        </Stack.Item>
    );
}

const ParameterGeomPolygon = ({
    generatePolygonDefinition,
    tempFeature,
    title,
    onSetGeometry
}) => {

    return (
        <Stack>
            <IfComp cond={!!title}>
                <Stack.Item className={classNames.title}>
                    <Text>{title}</Text>
                </Stack.Item>
            </IfComp>
            <GeometryParam
                generatePolygonDefinition={generatePolygonDefinition}
                tempFeature={tempFeature}
                onSetGeometry={onSetGeometry}
            />
        </Stack>
    );
}

export default ParameterGeomPolygon;
